module.exports = __webpack_public_path__ + "static/media/active_bar.6b7d1181.svg";